export const TILE_AUTH_PARAM_NAMES = ['Policy', 'Signature', 'Key-Pair-Id'];

/** Reject paths whose meaning can change during URL/proxy normalization. */
export function canonicalTilePath(path) {
    if (typeof path !== 'string' || !path.startsWith('/') || /[%](?:2f|5c|25|3f|23)/i.test(path)) {
        return null;
    }

    try {
        const decoded = decodeURIComponent(path);
        if (/[\\?#\u0000-\u001f\u007f]/.test(decoded) || decoded.includes('//')) return null;
        if (decoded.split('/').some(segment => segment === '.' || segment === '..')) return null;
        return decoded;
    } catch {
        return null;
    }
}

function validDomain(domain) {
    if (typeof domain !== 'string' || !domain || /[\s\\/?#@]/.test(domain)) return false;
    try {
        return new URL(`https://${domain}`).host === domain;
    } catch {
        return false;
    }
}

const validExpiry = value => typeof value === 'number' && Number.isFinite(value) && value > 0;

export function normalizeTileAuth(value) {
    if (!value || value.version !== 2 || !validExpiry(value.expires_at)
        || !Array.isArray(value.grants) || value.grants.length === 0) return null;

    const valid = value.grants.every(grant => {
        const prefix = canonicalTilePath(grant?.path_prefix);
        return validDomain(grant?.domain)
            && prefix !== null && prefix !== '/' && prefix.endsWith('/')
            && validExpiry(grant.expires_at)
            && TILE_AUTH_PARAM_NAMES.every(name => typeof grant.params?.[name] === 'string' && grant.params[name].length > 0);
    });

    return valid ? value : null;
}

export function tileAuthExpiresAt(value) {
    const auth = normalizeTileAuth(value);
    return auth ? Math.min(auth.expires_at, ...auth.grants.map(grant => grant.expires_at)) : null;
}
